import { render, staticRenderFns } from "./MovieCard.vue?vue&type=template&id=d242cc2a&scoped=true&"
import script from "./MovieCard.vue?vue&type=script&lang=js&"
export * from "./MovieCard.vue?vue&type=script&lang=js&"
import style0 from "./MovieCard.vue?vue&type=style&index=0&id=d242cc2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d242cc2a",
  null
  
)

export default component.exports